import illustrationStep1 from "./illustration-step1.png";
import illustrationStep2 from "./illustration-step2.png";
import illustrationStep3 from "./illustration-step3.png";
import illustrationStep4 from "./illustration-step4-1.png";
import illustrationStep5 from "./illustration-step4-2.png";
import illustrationSuccess from "./illustration-success.png";

export const IMAGES = {
	IllustrationSuccess: illustrationSuccess,
	IllustrationStep1: illustrationStep1,
	IllustrationStep2: illustrationStep2,
	IllustrationStep3: illustrationStep3,
	IllustrationStep4: illustrationStep4,
	IllustrationStep5: illustrationStep5,
} as const;
